import { Operator, LogicOperator, Logic, Expression, FilterItem } from "./";
import { makeAutoObservable } from "mobx";
import { v4 as uuid } from 'uuid'
import { _, indexDB } from "ynf-core-middleware";
import { operationLog } from '@actions';
// import _ from  "lodash";
import { OrderItem, OrderType } from "./OrderItem";
import render from 'ynf-core-engine/render'
import APIS from '../../api/filter/apis';

export class FilterStore {
  // 条件存储
  condition = new Logic(LogicOperator.AND);
  // 排序存储
  // eslint-disable-next-line no-array-constructor
  orderBy = new Array<OrderItem>();
  // 扩展条件存储
  extraCondition = new Map();
  // 真正执行查询的查询条件，为copy过去后最终执行的查询条件
  queryCondition: any = { conditions: [], orders: [] };

  advanceCondition: any = { op: 'and', items: [] };

  bAdvance: boolean = false;

  // 类型
  storeType: string = "FilterStore";
  // 是否触发，动态修改值，reaction 监听
  private $queryTrigger: number = 0;
  private $componentInit: number = 0;
  // 根Store
  rootStore: any;

  // 是否添加系统方案
  haveSystem: boolean;

  isUpdate: number = 0;

  // 查询区设置就绪
  isQueryReady: boolean;

  // storeMeta
  fieldsArr = new Map();
  FilterPanelJSONSchema: any = {
    isUpdate: 0
  };

  FilterSchemeJSONSchema: any = {
    haveSystem: false,
    updateSchemeList: 0,
    updateScheme: 0
  };

  FilterModalJSONSchema: any = {};
  APIS: APIS;

  // 构造函数
  constructor (storeMeta?: any, rootStore?: any) {
    this.rootStore = rootStore;
    this.haveSystem = false;
    // this.isUpdate = Date.now();
    this.isQueryReady = false;
    this.FilterPanelJSONSchema.utils = rootStore.utils
    this.FilterModalJSONSchema.utils = rootStore.utils
    this.FilterSchemeJSONSchema.utils = rootStore.utils
    this.FilterPanelJSONSchema.operationLog = this.operationLog.bind(this)
    this.FilterModalJSONSchema.operationLog = this.operationLog.bind(this)
    this.FilterSchemeJSONSchema.operationLog = this.operationLog.bind(this)
    this.APIS = new APIS(rootStore)
    makeAutoObservable(
      this,
      { rootStore: false, queryCondition: false, updateFilterItem: false, copyCondition: false },
      { autoBind: true }
    );
    // test code
    // this.addExtraCondition("ceshi", "and", [
    //   {
    //     name: "code",
    //     value: "23017",
    //     operator: "like",
    //   },
    //   {
    //     name: "title",
    //     value: "60",
    //     operator: "like",
    //   },
    // ]);
    // this.addCondition([
    //   {
    //     name: "code",
    //     value: "23017",
    //     operator: "like",
    //   },
    //   {
    //     name: "status",
    //     value: "60",
    //     operator: "eq",
    //   },
    // ]);
    // this.addOrderBy("code", "desc");
    this.initStoreMeta(storeMeta)
    this.initOrderBy(storeMeta)
    this.APIS.getParams({
      billNo: this.rootStore.pageStore.params.billNo,
      tplId: this.rootStore.pageStore.params.tplId,
      domainKey: this.rootStore.pageStore.params.domainKey,
      serviceCode: this.rootStore.pageStore.params.serviceCode,
      utils: this.rootStore.utils
    })
  }

  initStoreMeta (storeMeta: any) {
    storeMeta?.fieldsArr?.forEach((field: any) => {
      this.fieldsArr.set(field.alias, field)
    })
    this.initFilterJSONSchema()
  }

  initOrderBy(storeMeta: any) {
    try {
      // "[{'name':'dawenben','orderType':'asc'}]"
      const orderBy = storeMeta?.params?.orderBy
      const orderByArray = Array.isArray(orderBy) ? orderBy: eval(orderBy);
      orderByArray?.forEach((orderItem: any) => {
        const field = this.fieldsArr.get(orderItem?.name)?.field ?? orderItem?.name
        this.addOrderBy(field, orderItem.orderType);
      });
    } catch (error) {
      console.error('Error applying orderBy:', error);
    }
  }

  /**
   * 添加系统默认条件交易类型
   */
  initDefaultSystemCondition() {
    const transtype = this.rootStore?.pageStore?.query?.transtype
    if (transtype) {
      this.addCondition({name:'ynfTransType',value: transtype, operator:'eq' })
      this.copyCondition()
    }
  }


  /**
   * 初始化查询区JSONSchema
   */
  initFilterJSONSchema = () => {
    // 查询面板FilterPanel
    // function
    this.FilterPanelJSONSchema.initFiltersInfo = this.initFiltersInfo.bind(this)
    this.FilterPanelJSONSchema.setUpdate = this.setUpdate.bind(this)
    this.FilterPanelJSONSchema.getContitionList = this.getContitionList.bind(this)
    this.FilterPanelJSONSchema.setQueryReady = this.setQueryReady.bind(this)
    this.FilterPanelJSONSchema.validate = this.validate.bind(this)
    this.FilterPanelJSONSchema.copyCondition = this.copyCondition.bind(this)
    this.FilterPanelJSONSchema.onSearch = this.onSearch.bind(this)
    this.FilterPanelJSONSchema.setCondition = this.setCondition.bind(this)
    this.FilterPanelJSONSchema.getFilterItemByName = this.getFilterItemByName.bind(this)
    this.FilterPanelJSONSchema.render = this.renderPanelControls.bind(this)
    this.FilterPanelJSONSchema.getJSONSchema = this.getJSONSchema.bind(this)
    this.FilterPanelJSONSchema.getShowSearchCommons = this.getShowSearchCommons.bind(this)
    this.FilterPanelJSONSchema.deleteShowSearchCommon = this.deleteShowSearchCommon.bind(this)
    this.FilterPanelJSONSchema.expressionTransfer = this.expressionTransfer.bind(this)
    this.FilterPanelJSONSchema.setComponentInit = this.setComponentInit.bind(this)
    this.FilterPanelJSONSchema.initParams = this.initParams.bind(this)

    // properties
    this.FilterPanelJSONSchema.diworkCode = this.rootStore.pageStore?.params?.diworkCode
    this.FilterPanelJSONSchema.serviceCode = this.rootStore.pageStore?.params?.serviceCode

    // 查询方案FilterScheme
    this.FilterSchemeJSONSchema.getContitionList = this.getContitionList.bind(this)
    this.FilterSchemeJSONSchema.setCondition = this.setCondition.bind(this)
    this.FilterSchemeJSONSchema.validate = this.validate.bind(this)
    this.FilterSchemeJSONSchema.setUpdate = this.setUpdate.bind(this)
    this.FilterSchemeJSONSchema.setQueryTrigger = this.setQueryTrigger.bind(this)
    this.FilterSchemeJSONSchema.copyCondition = this.copyCondition.bind(this)
    this.FilterSchemeJSONSchema.initParams = this.initParams.bind(this)
    this.FilterSchemeJSONSchema.getMultiRes = this.getMultiRes.bind(this)
    this.FilterSchemeJSONSchema.multilingualMeta = this.multilingualMeta.bind(this)
    this.FilterSchemeJSONSchema.getJSONSchema = this.getJSONSchema.bind(this)
    this.FilterSchemeJSONSchema.chooseScheme = this.chooseScheme.bind(this)
    this.FilterSchemeJSONSchema.deleteScheme = this.deleteScheme.bind(this)
    this.FilterSchemeJSONSchema.getSolutionDataList = this.getSolutionDataList.bind(this)
    this.FilterSchemeJSONSchema.getSolutionMetaBySchemeId = this.getSolutionMetaBySchemeId.bind(this)
    this.FilterSchemeJSONSchema.expressionTransfer = this.expressionTransfer.bind(this)
    this.FilterSchemeJSONSchema.setDefaultScheme = this.setDefaultScheme.bind(this)
    this.FilterSchemeJSONSchema.getCandidateConditionsList = this.getCandidateConditionsList.bind(this)

    // 查询编辑弹窗FilterModal
    this.FilterModalJSONSchema.getSolutionMetaBySchemeId = this.getSolutionMetaBySchemeId.bind(this)
    this.FilterModalJSONSchema.getJSONSchema = this.getJSONSchema.bind(this)
    this.FilterModalJSONSchema.setAdvanceCondition = this.setAdvanceCondition.bind(this)
    this.FilterModalJSONSchema.removeAdvanceCondition = this.removeAdvanceCondition.bind(this)
    this.FilterModalJSONSchema.searchByFilter = this.searchByFilter.bind(this)
    // this.FilterModalJSONSchema.initSchemeModal = this.initSchemeModal.bind(this)
    this.FilterModalJSONSchema.render = this.renderModalControls.bind(this)
    this.FilterModalJSONSchema.getQueryValue = this._getQueryValue.bind(this)
    this.FilterModalJSONSchema.initParams = this.initParams.bind(this)
    this.FilterModalJSONSchema.isEmptyValue = this.isEmptyValue.bind(this)
    this.FilterModalJSONSchema.tplId = this.rootStore.pageStore.params.tplId
    this.FilterModalJSONSchema.billNo = this.rootStore.pageStore.params.billNo
  }

  /**
   * 初始化查询区面板，从ui元数据到组件认可的协议，同时生成FilterItem
   * @param $children render解析后的children
   * @returns 原始children列表，给设计器用
   */
  initFiltersInfo = ($children: { storeField: string; defaultValue: any; compareLogic: any; isSolution: any; visible: boolean; }[]) => {
    const originChildren = $children?.map((item: { storeField: string; defaultValue: any; compareLogic: any; isSolution: any; visible: boolean; }) => {
      const storeChildren = this.getContitionList();
      let value;
      storeChildren.forEach(child => {
        if (child.name === item.storeField) {
          value = child.value;
        }
      })
      return {
        name: item.storeField,
        value: value || item.defaultValue,
        operator: item.compareLogic,
        activated: item?.isSolution,
        visible: item.visible !== false,
        meta: item
      }
    })
    this.setCondition(originChildren)
    this.setSystem()
    return originChildren
  }

  /**
   * 获取描述组件的JSONSchema
   * @returns FilterPanelJSONSchema: {...} FilterSchemeJSONSchema: {...} FilterModalJSONSchema: {...}
   */
  getJSONSchema (controlType: string, flag: boolean) {
    switch (controlType) {
    case 'convenientquery':
      return this.FilterPanelJSONSchema
    case 'queryscheme':
      if (flag !== false) {
        this.FilterPanelJSONSchema.hasQueryScheme = true
        this.FilterModalJSONSchema.hasQueryScheme = true
      }
      return this.FilterSchemeJSONSchema
    case 'filtermodal':
      return this.FilterModalJSONSchema
    }
  }

  /**
   * 渲染查询区面板各组件
   * @param filterItemMeta {...Meta, value, onChange, context}
   * @returns ReactDOM
   */
  renderPanelControls (filterItemMeta: { meta: { store: string; }; name: any; }, isDesigner: boolean = false) {
    const meta: any = {
      ...filterItemMeta.meta
    }
    let storeStr = filterItemMeta.meta.store || '';
    if (storeStr.startsWith('mobx://rootStore.')) {
      storeStr = storeStr.replace('mobx://rootStore.', '');
    }
    meta.value = isDesigner ? meta.defaultValue : `mobx://rootStore.${storeStr}.getFilterItemByName('${filterItemMeta.name}').getValue()`
    meta.onChange = `mobx://rootStore.${storeStr}.getFilterItemByName('${filterItemMeta.name}').setValue`
    meta.context = this.rootStore.context
    meta.pageStore = this.rootStore.pageStore // 参照补pageStore
    if (['is_null', 'is_not_null'].includes(meta.compareLogic)) { // 非空为空转成disabled状态的input组件
      meta.disabled = true;
      meta.controlType = 'FilterInput';
      meta.libCode = 'ynf-lib-base';
      meta.value = meta.compareLogic === 'is_null' ? lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8011E', '为空', undefined, { returnDom: true, placement: 'top' }) : lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8011D', '非空', undefined, { returnDom: true, placement: 'top' });
    }
    return render(meta, { rootStore: this.rootStore || {} })
  }

  renderModalControls (copyElement: {
    canMultiple: any;
    compareLogic: any;
    disabled: any; controlType: string; libCode: any; renderAlias: any; refCode: any; refReturn: any; refReturnArr: any; defaultValue: any; cEntityKeyFld: any; value: any; caption: any; cEnumType: any; enumType: string | number; cEnumString: any; multiple: any;
}, extraProps: { parentAlias: any; onChange: any; value: any; }) {
    const { parentAlias, onChange, value } = extraProps;
    if (['is_null', 'is_not_null'].includes(copyElement.compareLogic)) {
      return render({
        disabled: 'true',
        libCode: 'ynf-lib-base',
        controlType: 'FilterInput',
        alias: copyElement.renderAlias,
        parentAlias,
        value: copyElement.compareLogic === 'is_null' ? lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8011E', '为空', undefined, { returnDom: true, placement: 'top' }) : lang.templateByUuid('UID:P_LIB-WEB-YNF-FE_18A210CE05A8011D', '非空', undefined, { returnDom: true, placement: 'top' })
      })
    } else if (['filterreferinputpc', 'filterreferinput', 'referinput', 'referinputpc'].includes(copyElement.controlType?.toLocaleLowerCase())) { // 参照
      return render({
        disabled: copyElement.disabled,
        libCode: copyElement.libCode,
        controlType: copyElement.controlType,
        alias: copyElement.renderAlias,
        parentAlias,
        refCode: copyElement.refCode, // 参照code
        refReturn: copyElement.refReturn, // 参照返回值
        refReturnArr: copyElement.refReturnArr, // 参照带入 // 不能传参照带入, 因为这里的modelPath已经不一样了, 不支持在查询方案里进行参照带入
        defaultValue: copyElement.defaultValue,
        cEntityKeyFld: copyElement.cEntityKeyFld,
        pageStore: this.rootStore.pageStore,
        value: copyElement.value,
        multiple: copyElement.multiple,
        canMultiple: copyElement.canMultiple,
        modalTitle: copyElement.caption, // 参照选择框弹出页面标题名称
        onOk: onChange
      }, {
        rootStore: this.rootStore
      })
    } else {
      return render({
        disabled: copyElement.disabled,
        libCode: copyElement.libCode,
        controlType: copyElement.controlType,
        alias: copyElement.renderAlias,
        parentAlias,
        cEnumType: copyElement.cEnumType, // 枚举code
        enumType: copyElement.enumType, // 枚举code
        cEnumString: copyElement.cEnumString, // 枚举数据源json
        multiple: copyElement.controlType === 'FilterEnumerate' ? copyElement.multiple : false, // 枚举多选
        enumData: this.rootStore.pageStore.enumData[copyElement.enumType],
        onChange,
        value
      })
    }
  }

  initParams (cb: any) {
    const params = {
      billNo: this.rootStore.pageStore.params.billNo,
      tplId: this.rootStore.pageStore.params.tplId,
      domainKey: this.rootStore.pageStore.params.domainKey,
      serviceCode: this.rootStore.pageStore.params.serviceCode,
      utils: this.rootStore.utils
    }
    cb(params)
  }

  // 获取缓存多语
  getMultiRes = async () => {
    const dbInstance = await indexDB.init("ynfMultiDB", 1, [
      { tableName: "ynfMultiCache", options: { keyPath: "ynfMultiId", autoIncrement: false } }
    ])
    const tplId = this.rootStore.pageStore?.params?.tplId
    const locale = this.getMultiLocale()
    const res = await dbInstance.query("ynfMultiCache", (item: { ynfMultiId: string; }) => item.ynfMultiId === `${tplId}_${locale}`)
    return res[0]?.data || {}
  }

  // 返回当前语种
  getMultiLocale = () => {
    const context = this.rootStore?.context
    const locale = context?.locale ?? 'zh-CN'
    return locale.replace('-', '_')
  }

  // 判断多语的开关
  isMultilingualFlag = () => {
    const context = this.rootStore?.context
    return typeof context?.ext?.multilingualFlag === 'boolean' ? context?.ext?.multilingualFlag : context?.tenant?.multilingualFlag
  }

  // 整理meta结构
  multilingualMeta = (meta: { [x: string]: any; }, multiRes: { [x: string]: any; }) => {
    if (!this.isMultilingualFlag()) {
      return meta
    } else {
      // const multiRes = await this.getMultiRes()
      Object.keys(meta).forEach(item => {
        const value = meta[item]
        if (item.indexOf('_resid') > -1 && multiRes[value] && multiRes[value] != value) {
          // 要替换的字段
          const replaceField = item.replace('_resid', '')
          // 替换
          meta[replaceField] = multiRes[value]
        }
      })
      return meta
    }
  }

  /**
   * 获取已选条件栏的数据
   * @returns [{ ...queryValue, caption, ...filterItem.meta }, { ...queryValue, caption, ...filterItem.meta }), ......]
   */
  getShowSearchCommons () {
    const commonVOs: any = []
    this.getContitionList().forEach(filterItem => {
      const queryValue = filterItem.getQueryValue()
      const caption = filterItem.meta.caption_resid ? lang.templateByUuid(filterItem.meta.caption_resid, filterItem.meta.caption) : filterItem.meta.caption
      if (['FilterReferInputPc', 'FilterReferInput'].includes(filterItem.meta.controlType)) {
        const refReturn = filterItem.meta.refReturn;
        const referValue = filterItem.getValue()
        if (typeof refReturn === 'string') {
          queryValue.v1 = referValue?.[refReturn] ?? ''
        } else {
          const nameArr: any[] = []
          refReturn.forEach((i: string | number) => {
            if (!this.isEmptyValue(referValue?.[i])) nameArr.push(referValue[i])
          });
          queryValue.v1 = nameArr.join('-')
        }
      } else if (filterItem.meta.mulFieldLike?.length) { // 关键字搜索
        const tempArr: any = []
        queryValue.items?.forEach(item => {
          tempArr.push(item.v1)
        })
        queryValue.v1 = tempArr[0]
      } else if (filterItem.meta.enumData) {
        let enumData = filterItem.meta.enumData.startsWith('mobx://') ? filterItem.meta.enumData.replace('mobx://', '') : filterItem.meta.enumData
        const enumType = filterItem.meta.enumType;
        enumData = this.rootStore.pageStore.enumData[enumType]
        const enumValue = queryValue.v1?.split(',')
        if (!this.isEmptyValue(enumValue)) {
          const enumValueArr = enumData?.filter(item => enumValue.includes(item.key))
          queryValue.v1 = enumValueArr.map(item => item.value)?.join(',')
        }
      }
      if (!this.isEmptyValue(queryValue.v1) || !this.isEmptyValue(queryValue.v2)) {
        commonVOs.push({ ...queryValue, caption, ...filterItem })
      }
    })
    return commonVOs
  }

  /**
   * 已选条件删除选项
   */
  deleteShowSearchCommon (filterItem) {
    this.getFilterItemByName(filterItem.name).setValue()
  }

  /**
   * 切换方案
   * @param val 方案数据
   */
  chooseScheme (val: any) {
    this.FilterPanelJSONSchema.currentScheme = val
    this.FilterSchemeJSONSchema.currentScheme = val
    this.FilterModalJSONSchema.currentScheme = val
  }

  /**
   * 删除方案
   * @param solutionId 方案ID
   */
  async deleteScheme (solutionId: string | number) {
    await this.APIS.delSolution(solutionId)
    await this.getSolutionDataList()
    this.FilterSchemeJSONSchema.updateSchemeList++
  }

  /**
   * 获取方案列表数据，并更新
   */
  async getSolutionDataList () {
    const schemeList = await this.APIS.getSolutionList() || [];
    if (this.FilterSchemeJSONSchema.systemScheme) {
      schemeList.unshift(this.FilterSchemeJSONSchema.systemScheme)
    }
    this.FilterSchemeJSONSchema.schemeList = schemeList
    this.FilterSchemeJSONSchema.updateSchemeList++
  }

  /**
   * 根据方案id查询方案元数据
   * @param val 方案数据
   * @returns 当前方案条件数据
   */
  getSolutionMetaBySchemeId (val) {
    const schemeList = this.FilterSchemeJSONSchema.schemeList || []
    const fieldsArr = this.getContitionList()
    const data = schemeList.find(item => item.solutionId === val.solutionId)
    if (this.isEmptyValue(data)) return
    if (data.fields.length === 0) { // 用户没有设置默认方案, 用系统方案
      const defaultFileds = fieldsArr.filter(item => item.meta.isSolution === true || item.meta.isSolution === undefined) // 从所有查询区字段中筛选默认字段
      data.fields = [...defaultFileds]
    }
    data.fields = data.fields.filter(item => {
      const tempItem = this.expressionTransfer(item)
      return tempItem.visible !== false && item.visible !== false
    })
    return data;
  }

  /**
   * 设置默认方案
   * @param solutionId 方案id
   */
  async setDefaultScheme (solutionId: string | number) {
    await this.APIS.setDefaultFilter(solutionId === 'systemScheme' ? "-2" : solutionId)
    await this.getSolutionDataList()
  }

  expressionTransfer (filterItem: any) {
    const temp: any = {}
    Object.keys(filterItem).forEach(property => {
      if (filterItem[property]?.startsWith?.('mobx://') && ['visible', 'disabled', 'required'].includes(property)) { // 暂时遇到visible，其他的不能转
        temp[property] = eval(filterItem[property].replace("mobx://", ''))
      }
    })
    return temp
  }

  /**
   * 处理备选条件列表
   * @param fieldsArr 所有备选查询条件
   * @returns 处理后的查询条件列表
   */
  getCandidateConditionsList (fieldsArr: any = [], extraProps: any = {}) {
    if (fieldsArr.length === 0) {
      fieldsArr = _.cloneDeep(this.getContitionList())
    }
    const { parentAlias } = extraProps;
    return fieldsArr.map(f => {
      // const bizTypeKey = f.bizType;
      const item = { ...f.meta };
      item.id = f.meta.storeField;
      item.alias = f.meta.controlType + uuid().slice(0, 4);
      item.controlType = f.meta.controlType || 'Input';
      item.libCode = f.meta.libCode || 'ynf-lib-base';
      item.value = f.meta?.defaultValue;
      // item.cEnumType = f.meta.cEnumType; // 枚举code
      // item.multiple = f.meta.multiple; // 枚举单选多选
      // item.refCode = f.meta.refCode; // 参照code
      // item.refReturn = f.meta.refReturn; // 参照返回字段
      // item.refReturnArr = f.meta.refReturnArr;
      item.bAutoflt = f.meta?.bAutoflt || false; // 值改变搜索
      item.compType = f.meta.compType || 'xcontrol';
      item.parentAlias = parentAlias;
      // 比较符
      if (f.meta.controlType === 'FilterInput') {
        item.compareLogic = item.compareLogic || 'like';
      } else if (f.meta.controlType === 'FilterEnumerate' && item.multiple) { // 枚举多选默认值为in
        item.compareLogic = item.compareLogic || 'in';
      } else if (f.meta.controlType === 'FilterDateRangePicker') {
        item.compareLogic = item.compareLogic || 'between';
      } else {
        item.compareLogic = item.compareLogic || 'eq';
      }
      const tempItem = this.expressionTransfer?.(item)
      if (item.visible !== false && tempItem.visible !== false) {
        return item;
      }
    }).filter(item => item != undefined);
  }

  /**
   * 初始化弹窗模型
   */
  initSchemeModal () {
    this.FilterModalJSONSchema.schemeModal = _.cloneDeep(this.getContitionList())
  }

  _getQueryValue = (meta: any) => {
    let { value, compareLogic, field, storeField } = meta
    let mulFieldLike = meta?.mulFieldLike;
    if (mulFieldLike && mulFieldLike.length) {
      mulFieldLike = Array.isArray(mulFieldLike)
        ? mulFieldLike
        : mulFieldLike.split(",");
      if (value) {
        const items: any = [];
        mulFieldLike.forEach((name: string) => {
          items.push({ op: compareLogic, name: field || name, v1: value });
        });
        return { op: "or", items };
      }
    }

    if (meta?.compareLogic === 'multlike') {
      const values = value?.split(/\s+/)
      if (values.length > 0) {
        const items: any = [];
        values.forEach((value: string) => {
          items.push({ op: 'like', name: field || storeField, v1: value });
        });
        return { op: "or", items };
      }
    }

    if (value && !Array.isArray(value) && meta?.controlType === 'FilterDateRangePicker') {
      // 移动传过来的值与pc不一致
      const getDataStr = (dateStr: string | number | Date) => {
        const dateObj = new Date(dateStr);
        const year = dateObj.getFullYear();
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');
        const modifiedDateStr = `${year}-${month}-${day}`;
        return modifiedDateStr
      }
      const v1 = getDataStr(value?.sDate) + ' ' + '00:00:00'
      const v2 = getDataStr(value?.eDate) + ' ' + '00:00:00'
      return { op: meta?.compareLogic || 'between', name: field || storeField, v1, v2 }
    }
    // this.operator?.operator !== Operator.IN  如果是  in 条件，
    let v1, v2;
    // 如果 count 大于2 并且不是in 条件，处理成2个+字段
    // 如果是 in 条件，直接处理 为 在 v1 上 一个值
    if (compareLogic === 'between') {
      // 容错处理
      if (value && Array.isArray(value)) {
        v1 = value[0];
        v2 = value[1];
      }
    } else {
      // 如果是参照
      if (
        meta?.controlType === "ReferInputPc" ||
        meta?.controlType === "ReferInput" ||
        meta?.controlType === "FilterReferInputPc" ||
        meta?.controlType === "FilterReferInput"
      ) {
        // 找到查询区的主键，取真实值
        try {
          const refReturnArr = JSON.parse(meta.refReturnArr || "{}");
          let primaryKey = "";
          Object.keys(refReturnArr).forEach((key) => {
            const arr = refReturnArr[key].split(",");
            if (arr.pop() === storeField) {
              primaryKey = key;
            }
          });
          // 婷艳说：如果是单选参照，在查询区中，传多个值。canMultiple =true 并且 vlues 数组，有值
          const vals: any[] = [];
          if (
            meta.canMultiple &&
            Array.isArray(value) &&
            value.length
          ) {
            value.forEach((item: any) => {
              vals.push(item[primaryKey]);
            });
            v1 = vals;
            // FIXME: 下面这些逻辑都是不应该的，兼容历史错误协议的代码，请若干时间后修复
            if (!['in', 'nin'].includes(compareLogic)) {
              if (compareLogic === 'neq') {
                compareLogic = 'nin';
              } else if (compareLogic === 'eq') {
                compareLogic = 'in';
              }
            }
          } else {
            v1 = value?.[primaryKey];
          }
        } catch (e) {
          console.log(`查询条件${storeField}异常`);
          v1 = undefined;
        }
      } else {
        // 如果是 enumValueSplit 枚举状态 处理成拆分
        // if (this.meta.enumValueSplit) {
        //   v1 = this.value?.split(",");
        // } else {
        v1 = value;
        // }
      }
    }
    return Object.fromEntries(
      Object.entries({
        op: compareLogic,
        // value: this.value,
        name: field || storeField,
        v1,
        v2
      }).filter(([, v]) => v != null)
    );
  }

  setAdvanceCondition = (condition) => {
    this.advanceCondition.items = condition
  }

  removeAdvanceCondition = () => {
    this.advanceCondition.items = []
  }

  operationLog = (operCode: string) => {
    operationLog?.call(this, this.rootStore, { operCode }); // 操作日志
  }

  searchByFilter = () => {
    this.setQueryTrigger(false)
    this.bAdvance = true
  }

  isEmptyValue (value: any) {
    if (typeof value === 'object') {
      let t;
      // eslint-disable-next-line no-unreachable-loop
      for (t in value) { return !1; } // 一次就好
      return !0
    } else {
      return value == null || value === '';
    }
  }

  /**
   * 校验查询区条件是否必填
   * @returns [{name:status,message:'该条件是必填条件'}]
   */
  validate () {
    return this.condition.validate();
  }

  /**
   * 添加条件
   * @param conditions [{name:code,value:123,operator:'like'/eq/in/between }]/{name:code,value:123,operator:'like'/eq/in/between }
   */
  addCondition(conditions: any) {
    conditions = Array.isArray(conditions) ? conditions : [conditions];
    conditions = conditions.filter((item: any) => item?.hasOwnProperty('name'));
    conditions.forEach((item: any) => {
      this.condition.addFilter(this.createFilterItem(item));
    });
  }

  /**
   * 添加默认like查询条件，同步条件到真正查询
   * @param conditions [{key: value}, {code: '123'}]
   */
  addDefLikeCondition (conditions: any) {
    this.upsertDefCondition(conditions, 'like')
  }

  /**
   * 添加eq查询条件，同步条件到真正查询
   * @param conditions [{key: value}, {code: '123'}]
   */
  addDefEqCondition (conditions: any) {
    this.upsertDefCondition(conditions, 'eq')
  }

  /**
   * 添加简易条件的查询条件，同步条件到真正查询
   * @param conditions  [{key: value}, {code: '123'}]
   */
  upsertDefCondition (conditions: any, operator?: string) {
    const condition = this.transformedData(conditions, operator)
    this.addCondition(condition)
    this.copyCondition()
  }

  private transformedData (conditions: any, operator?: string) {
    conditions = Array.isArray(conditions) ? conditions : [conditions];
    return conditions.map((obj: object) => {
      return Object.entries(obj)?.map(([key, value]) => ({
        name: key,
        value,
        operator
      }));
    }).flat();
  }

  /**
   * 查询区 全量更新
   * @param conditions
   */
  setCondition (conditions: any) {
    this.condition.expressionList = [];
    conditions = Array.isArray(conditions) ? conditions : [conditions];
    const resultCons: Array<FilterItem> = [];
    conditions.forEach((item: any) => {
      // 传过来的参数，有重复，需要把最新的update老的，没有新增,resultCons 引用修改
      this.updateFilterItem(resultCons, this.createFilterItem(item));
    });
    this.condition.expressionList = resultCons
  }

  /**
   * updateFilterItem 工具方法，类似于之前的updateCondition
   * @param list
   * @param item
   * @returns
   */
  updateFilterItem (list: Array<FilterItem>, item: FilterItem):Array<FilterItem> {
    let flag = false;
    list.forEach((f, i) => {
      if (f.getName() === item.getName()) {
        list[i] = item;
        flag = true;
      }
    });
    if (!flag) {
      list.push(item);
    }
    return list;
  }

  /**
   * 清空查询区条件的值
   */
  clearConditionValue () {
    this.condition.clearValue();
  }

  /**
   * 清空扩展条件的值
   */
  clearExtraConditionValue () {
    this.extraCondition.forEach((item) => {
      item.clearValue();
    });
  }

  /**
   * 清空所有条件
   */
  clear () {
    this.clearConditionValue();
    this.clearExtraConditionValue();
  }

  /**
   * 查询区准备就绪
   */
  setQueryReady () {
    this.isQueryReady = true;
    this.FilterPanelJSONSchema.isQueryReady = true
  }

  /**
   * 设置条件更新
   */
  setUpdate () {
    this.isUpdate = Date.now();
    this.FilterPanelJSONSchema.isUpdate = Date.now();
  }

  /**
   * 设置为添加过系统方案
   */
  setSystem () {
    this.FilterSchemeJSONSchema.haveSystem = true
    this.haveSystem = true;
  }

  /**
   * 删除条件，根据FilterItem 对象 或者 name
   * @param name
   */
  removeCondition (item: string | FilterItem | [string | FilterItem]) {
    item = Array.isArray(item) ? item : [item];
    item.forEach((con: string | FilterItem) => {
      this.condition.removeFilter(con);
    });
  }

  /**
   *  根据filterItem 更新条件
   * @param filterItem
   */
  updateCondition (item: any) {
    this.condition.updateFilter(this.createFilterItem(item));
  }

  /**
   * 创建 FilterItem
   * @param item 查询条件对象 { name, value, operator }
   * @returns FilterItem
   */
  createFilterItem (item: any): FilterItem {
    let {
      name,
      value,
      activated = true,
      visible = true,
      meta = {},
      operator = "eq"
    } = item;
    // if (meta.enumValueSplit) {
    //   // eslint-disable-next-line no-const-assign
    //   operator = "in";
    // }
    // 兼容，如果没有 storeFiled的时候。用 alias代替
    name = name || meta.alias;
    const field = this.fieldsArr.get(name)?.field
    if (['is_null', 'is_not_null'].includes(meta.compareLogic)) {
      value = meta.compareLogic
    }
    return new FilterItem(
      name,
      value,
      operator === "between" ? Operator.BETWEEN : new Operator(operator),
      activated,
      visible,
      meta,
      field,
      this
    );
  }

  /**
   * 根据name 获取 查询项
   * @param name
   * @returns item
   */
  getFilterItemByName (name: string): FilterItem | Logic | null | any {
    return this.condition.getFilterItemByName(name);
  }

  /**
   * 获取默认的查询条件
   */
  getCondition () {
    return this.condition
  }

  /**
   * 获取默认查询区的所有FilterItems,包括 Logic
   * @returns 获取默认查询区的所有FilterItems
   */
  getContitionList () {
    return this.condition.expressionList.map(({ filterStore, ...rest }) => rest)
    // return this.condition.expressionList;
  }

  // getContitionList是老代码即将废弃
  getConditionList () {
    return this.condition.expressionList.map(({ filterStore, ...rest }) => rest)
  }

  get conditionList () {
    return this.condition.expressionList;
  }

  /**
   * beforeSearch
   */
  onBeforeSearch = () => {
    // 可以重写，扩展自己的方法
  };

  // 触发
  onSearch = () => {
    this.setQueryTrigger();
  };

  setComponentInit = () => {
    this.$componentInit = performance.now();
  }

  get queryTrigger () {
    return this.$queryTrigger;
  }

  get componentInit () {
    return this.$componentInit;
  }

  /**
   * 触发查询
   * @param value
   */
  setQueryTrigger (flag: boolean = true) {
    if (flag !== false) this.bAdvance = false // 高级查询标记
    this.$queryTrigger = performance.now();
    this.$componentInit = performance.now();
  }

  /**
   * 获取全部条件
   * @returns 返回 { conditions, orders }
   */
  getAllCondition () {
    const conditions = this.mergeCondition().map((item) =>
      item.getQueryValue()
    );
    const orders = this.getOrderBy().map((item) => item.getQueryValue());
    // return { conditions:[{items: [{ name: "reDirection", op: "in", v1: ["1"] },{items: [{name: "title",op: "like",v1: '60'},{name: "code",op: "like",v1: '60'}],op: "or"}], op: "and" }], orders };
    return { conditions, orders };
  }

  /**
   * 合并扩展和默认条件
   * @returns 返回list 集合
   */
  mergeCondition () {
    const extra = this.getExtraCondition();
    const def = this.getCondition();
    return [...extra, def];
  }

  /**
   * copy 条件 到 查询执行条件
   */
  copyCondition () {
    const conditions = [this.getCondition()].map((item) =>
      item.getQueryValue(true)
    );
    this.queryCondition.conditions = conditions;
  }

  /**
   * copy 用户自定义扩展条件
   */
  copyExtraCondition () {
    const extra = this.getExtraCondition();
    return [...extra].map((item) => item.getQueryValue(true));
  }

  /**
   * 获取真正的查询条件，点击查询copy后的，并且用户自己扩展的，+ order的
   */
  getQueryCondition () {
    if (this.bAdvance) {
      return {
        conditions: [
          this.advanceCondition
        ],
        orders: this.getOrderBy(true).map((item) => item.getQueryValue())
      }
    } else {
      return {
        conditions: [
          ...this.queryCondition.conditions,
          ...this.copyExtraCondition()
        ],
        orders: this.getOrderBy(true).map((item) => item.getQueryValue())
      }
    }
  }

  /**
   * 添加扩展条件，增加个logic 与 默认条件平级
   * @param 扩展Logic 别名
   * @param operator 与其他条件的操作符关系，or 或者 and
   * @param value [{name:code,value:123,operator:'like'/eq/in/between }]/{name:code,value:123,operator:'like'/eq/in/between }
   */
  addExtraCondition (key: string, operator: string | Operator, values: any) {
    // 如果不是operator 创建operator
    if (!(operator instanceof Operator)) {
      operator = new Operator(operator);
    }
    const l = new Logic(operator, key);
    values = Array.isArray(values) ? values : [values];
    values.forEach((item: any) => {
      l.addFilter(this.createFilterItem(item));
    });
    this.extraCondition.set(key, l);
  }

  /**
   * 删除扩展
   * @param key 扩展Logic 别名
   */
  removeExtraCondition (key: string) {
    this.extraCondition.delete(key);
  }

  /**
   * 更新扩展
   * @param 扩展Logic 别名
   * @param operator 与其他条件的操作符关系，or 或者 and
   * @param value [{name:code,value:123,operator:'like'/eq/in/between }]/{name:code,value:123,operator:'like'/eq/in/between }
   */
  updateExtraCondition (key: string, operator: string, values: any) {
    this.addExtraCondition(key, operator, values);
  }

  /**
   * 获取扩展查询条件
   * @param key 扩展map的key
   * @returns
   */
  getExtraCondition (key?: string) {
    // 获取当前的数据
    if (key) {
      return this.getExtraConditionData(key);
      // const conditionValue = this.extraCondition.get(key);
      // // 根据存储的条件的datapath返回数据 logic filter
      // if (conditionValue instanceof Logic) {
      //   return this.getExtraConditionData(key);
      // } else if (conditionValue instanceof FilterItem) {
      //   return this.getExtraConditionData(key);
      // }
    } else {
      // key为空时候输出所有condition
      // const conditions = this.extraCondition;
      const queryCondition: (Expression | undefined)[] = [];
      this.extraCondition.forEach((_value, key) => {
        const extraCondition = this.getExtraConditionData(key);
        queryCondition.push(extraCondition);
      });
      return queryCondition;
    }
  }

  /**
   * 获取查询条件数据
   * @param key key
   * @returns extraConditionData
   */
  getExtraConditionData (key: string) {
    const conditionValue = _.cloneDeep(this.extraCondition.get(key));
    return conditionValue;
  }
  // createQueryItems(op: any, queryMeta: any) {
  //   // 构建查询子项 - 放入到condition
  //   // eslint-disable-next-line no-array-constructor
  //   const list = Array<FilterItem>();
  //   queryMeta.forEach((queryItem: any) => {
  //     const { field: name, compareLogic, modelPath } = queryItem;
  //     list.push(new FilterItem(name, new Operator(compareLogic), modelPath));
  //   });
  //   const condition = new Logic(op || LogicOperator.AND);
  //   condition.setExpressionList(list);
  //   this.condition = condition;
  // }

  /**
   * 获取orderBy
   * isActivated 是否是激活的排序条件。true 只选激活的。false 全部
   * @returns 获取orderBy
   */
  getOrderBy (isActivated = false) {
    return isActivated
      ? this.orderBy.filter((orderItem) => orderItem.activated)
      : this.orderBy;
  }

  /**
   * 增加排序条件
   * @param name name
   * @param value desc
   */
  addOrderBy (
    name: string,
    value: OrderType = OrderType.asc,
    activated = true,
    visible = true,
    meta = {}
  ) {
    if (name.length < 1) {
      throw new Error("field is null");
    }
    const foundItem = this.orderBy.find(item => item.name == name);
    // 添加查询列表排序字段
    if (foundItem) {
      this.updateOrderBy(name, value, activated, visible)
    } else {
      this.orderBy.push(new OrderItem(name, value, activated, visible, meta));
    }
  }

  /**
   * 删除某个条件
   * @param name  根据key
   */
  removeOrderBy (name: string) {
    this.orderBy = this.orderBy.filter((item) => item.name !== name);
  }

  /**
   * 更新排序字段
   * @param name 排序字段key
   * @param value  value
   */
  updateOrderBy (
    name: string,
    value: OrderType = OrderType.asc,
    activated = true,
    visible = true
  ) {
    this.orderBy.forEach((orderItem: OrderItem) => {
      if (orderItem.name === name) {
        orderItem.setValue(value);
        orderItem.setActivated(activated);
        orderItem.setVisible(visible);
      }
    });
  }
}
